module.exports = __webpack_public_path__ + "img/rokustore2.2766c924.png";